<template>
  <div
    v-if="open"
    class="sample-details"
  >
    <table class="sample-details__table">
      <colgroup>
        <col class="column-check">

        <col class="column-barcode">

        <col class="column-exams">

        <col
          v-if="sample.paternity_name"
          class="column-participant"
        >

        <col class="column-end">

        <col class="column-actions">

        <col class="column-end">
      </colgroup>

      <thead class="sample-details__table-head">
        <tr class="sample-details__row-with-separator">
          <th />

          <th>CÓD DE BARRAS</th>

          <th>EXAMES</th>

          <th v-if="sample.paternity_name">
            PARTICIPANTE
          </th>

          <th
            colspan="2"
            class="samples-actions"
          />

          <th />
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(exam, rowIndex) in sample.exams"
          :key="rowIndex"
          class="sample-details__row"
        >
          <td />

          <td>
            <span :title="sample.bar_code">{{ sample.exams.indexOf(exam) === 0 ? sample.bar_code : '' }}</span>
          </td>

          <td>
            <span
              v-if="exam.code"
              :title="exam.code + ' - ' + exam.exam_name"
            >{{ exam.code }} - {{ exam.exam_name }}</span>

            <span
              v-else
              :title="exam.exam_name || exam.description"
            >{{ exam.exam_name || exam.description }}</span>
          </td>

          <td>
            <span
              v-if="sample.paternity_name"
              :title="getPaternityName(sample)"
            >{{ getPaternityName(sample) }}</span>
          </td>

          <td
            class="document-upload-button"
            colspan="3"
          >
            <button
              v-if="toggle.userExamDocument && exam.docRequired"
              class="status-icon document-upload-button"
              :class="`document-upload-button-${exam.docDelivered ? 'uploaded' : 'missing'}`"
              @click="redirectToDocRequiredPage"
            >
              <svg-loader
                v-if="exam.docDelivered"
                src="/static/images/icon-doc-button-upload-uploaded.svg"
              />

              <svg-loader
                v-else
                src="/static/images/icon-doc-button-upload-missing.svg"
              />

              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                <span v-if="!exam.docDelivered">Anexar documento(s).</span>

                <span v-else>Documento(s) já anexado(s).</span>
              </md-tooltip>

              <span>DOC</span>
            </button>
          </td>

          <td class="samples-actions" />

          <td />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import strings from '@/strings'

import DocumentUploadButton from '../../Documents/Laboratory/Modal/OpenModalButton'

export default {
  name: 'SampleDetails',
  components: {
    DocumentUploadButton
  },
  props: {
    sample: Object
  },
  data() {
    return {
      examForExclusion: {},
      participantsRelationshipOptions: strings.participantsRelationship,
      open: false
    }
  },
  computed: {
    ...mapGetters([
      'toggle'
    ]),
  },
  methods: {
    getPaternityName(sample) {
      let relationshipName =
        ' (' +
        this.participantsRelationshipOptions.filter(
          relationship => relationship.value === sample.paternity_relationship
        )[0].label +
        ')'
      return sample.paternity_name + relationshipName
    },
    getExamId({ examName, listId }) {
      let index = listId.findIndex(item => item.exam_sent === examName)
      return listId[index].id
    },
    getExamDocuments({ examName, listId }) {
      let index = listId.findIndex(item => item.exam_sent === examName)
      return listId[index].documentExamsRequired
    },
    reloadList() {
      this.$emit('refresh-samples')
    },
    redirectToDocRequiredPage() {
      this.$router.push('/documentos-obrigatorios')
    },
    toggleVisibility() {
      this.open = !this.open

      this.$emit('toggle-visibility', this.open)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../static/stylesheets/mixins';

.sample-details {
  background: #ebebeb;
  padding-bottom: 5px;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  position: relative;

  &__row {
    td {
      padding-top: 20px;
      text-align: left !important;
    }
  }

  &__row-with-separator {
    th {
      text-align: left !important;
      padding-bottom: 10px !important;
      border-bottom: 2px solid #fff;
      &:first-of-type {
        border-bottom: none;
      }
      &:last-of-type {
        border-bottom: none;
      }
    }
  }

  .column-check {
    width: 45px;
  }
  .column-barcode {
    width: 20%;
  }

  .column-exams {
    width: 70%;
  }

  .column-participant {
    width: 29%;
  }
  .column-actions {
    width: 14%;

    @media screen and (max-width: 1154px) {
      width: 15%;
    }
  }

  .document-upload-button {
    width: 62px;
    height: 23px;
    font-family: Roboto-bold, Roboto, sans-serif;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 12.5px;
    margin-right: 20px;
    margin-bottom: -10px;
    overflow: visible;

    .md-icon {
      position: relative;
      right: 3px;
    }

    span {
      margin: auto 6px auto 0;
    }

    &-missing {
      background-color: #fb8a00;
    }

    &-uploaded {
      background-color: #21d09b;
    }
  }

  .column-end {
    width: 3.4%;
  }

  .samples-actions {
    text-align: center;
  }
}

.btn-create-exam {
  height: 30px;
  font-size: 11px;
  letter-spacing: 0.4px;
  width: 163px;
  padding-top: 1px;
  margin: 0 auto;
}
</style>
